// 开启自动充值时后端返回的「无可用支付方式」类错误码，文案与 Home AutoRechargeDialog 对齐
// 80E00126 no payment method / 80E00127 not exist / 80E00104 request strip exception
export const NO_PAYMENT_METHOD_CODES = ['80E00126', '80E00127', '80E00104']

export const NO_PAYMENT_METHOD_MESSAGE = 'Payment method is not saved. Please set up your payment method prior to auto-recharge.'

export function isNoPaymentMethodError (errorCode) {
  return NO_PAYMENT_METHOD_CODES.includes(errorCode)
}
